import * as types from './mutation-types'
import {ADD_QUESTION} from "./mutation-types";

export default {
    [types.LOAD_QUESTIONS] (state, questions) {
        state.questions = questions.data
    },

    [types.LOAD_QUESTION] (state, question) {
        state.question = question.data
    },

    [types.ADD_QUESTION]: (state, data) => {
        state.questions.push(data)
    }
}